import "../../styles/studio/visualization/titleInput.css";

const MAX_TITLE_LENGTH = 100;

const TitleInput = ({ title, setTitle, isLoading }) => {
  return (
    <div className="title-input">
      <label className="title-label">
        Title <span className="required">*</span>
      </label>

      <input
        type="text"
        placeholder="Enter visualization title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        maxLength={MAX_TITLE_LENGTH}
        className="title-field"
        disabled={isLoading}
      />

      <div className="title-meta">
        <span className="hint">Be clear and descriptive</span>
        <span className="count">
          {title.length}/{MAX_TITLE_LENGTH}
        </span>
      </div>
    </div>
  );
};

export default TitleInput;
